import React from 'react';
import AmenityIcon from 'shared/components/LocalAreaMap/AmenityIcon/AmenityIcon';
import kebabCase from 'lodash/kebabCase';
import { ListingAmenitiesProps } from './ListingAmenities.types';
import {
    AmenitiesList,
    StyledAmenityIcon,
    AmenityTitle,
    AmenityDistance,
    AmenityItem,
    Disclaimer
} from './ListingAmenities.styles';

type AmenityProps = {
    title: string;
    type: string;
    distanceMiles: number | null | undefined;
};

const isNumber = (value: number | null | undefined): boolean =>
    typeof value === 'number' ? true : false;

const Amenity = ({ title, type, distanceMiles }: AmenityProps) => (
    <AmenityItem
        key={title}
        data-testid={`amenity-item-list-${kebabCase(title)}`}
    >
        <StyledAmenityIcon>
            <AmenityIcon type={type} />
        </StyledAmenityIcon>
        <AmenityTitle>{title}</AmenityTitle>
        <AmenityDistance>{distanceMiles} miles</AmenityDistance>
    </AmenityItem>
);
const ListingPOI = ({ data }: ListingAmenitiesProps) => {
    return (
        <>
            {data.pointsOfInterest?.length ? (
                <>
                    <AmenitiesList data-testid="amenities-list">
                        {data.pointsOfInterest.map((amenity, index) =>
                            amenity.title &&
                            amenity.type &&
                            isNumber(amenity.distanceMiles) ? (
                                <Amenity
                                    key={`amenity-${index}-${amenity.title}`}
                                    title={amenity.title}
                                    type={amenity.type}
                                    distanceMiles={amenity.distanceMiles}
                                />
                            ) : null
                        )}
                    </AmenitiesList>
                    <Disclaimer size="secondary" color="text-placeholder">
                        <span>
                            These distances are calculated in a straight line.
                        </span>{' '}
                        <span>The actual route and distance may vary.</span>
                    </Disclaimer>
                </>
            ) : null}
        </>
    );
};

export default ListingPOI;
